import { render, staticRenderFns } from "./StuCareArchivesRecord.vue?vue&type=template&id=d7686e42&scoped=true"
import script from "./StuCareArchivesRecord.vue?vue&type=script&lang=js"
export * from "./StuCareArchivesRecord.vue?vue&type=script&lang=js"
import style0 from "./StuCareArchivesRecord.vue?vue&type=style&index=0&id=d7686e42&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7686e42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7686e42')) {
      api.createRecord('d7686e42', component.options)
    } else {
      api.reload('d7686e42', component.options)
    }
    module.hot.accept("./StuCareArchivesRecord.vue?vue&type=template&id=d7686e42&scoped=true", function () {
      api.rerender('d7686e42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/mentalHealth/ArchivesViewPage/components/StuCareArchivesRecord.vue"
export default component.exports